import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("d2w_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const bikeImage = (img) =>
  img && img.startsWith("deal2wheel/") ? `${API}/files/${img}` : img;

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const formatKm = (n) => `${Number(n || 0).toLocaleString("en-IN")} km`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
